import styled from 'styled-components';
import { Sheet } from '../../../components/Modal';

export const Field = styled.div`
  padding: 1rem 0;
`;

export const ModalInner = styled(Sheet)`
  background: #fff;
  border-radius: 4px;
  padding: 1rem;
`;

export const PlaceholderSelectionImg = styled.img`
  width: 50px;
  opacity: ${(props) => (props.selected ? 1 : 0.2)};
  cursor: pointer;
`;

export const NoImgSelection = styled.div`
  cursor: pointer;
  width: 50px;
  line-height: 50px;
  opacity: ${(props) => (props.selected ? 1 : 0.2)};
`;

export const PlaceholderList = styled.div`
  display: flex;
`;
